import React from 'react';
import { Users, Library, TrendingUp } from 'lucide-react';
const WhyPractitionersSection = () => {
  return <section className="py-20 px-6 md:px-12 bg-gradient-to-b from-white to-teal-50" data-id="element-312">
      <div className="max-w-6xl mx-auto" data-id="element-313">
        <div className="text-center mb-16" data-id="element-314">
          <h2 className="text-3xl md:text-5xl font-bold text-teal-900 mb-6 leading-tight" data-id="element-315">
            Why Practitioners Are Calling This Their New Secret Weapon for
            Client Breakthroughs
          </h2>
          <p className="text-xl md:text-2xl text-teal-800 font-medium mb-8 max-w-4xl mx-auto" data-id="element-316">
            Get Your Clients Better Results Between Sessions (So They Stay With
            You Longer)
          </p>
          <div className="h-1 w-24 bg-teal-600 mx-auto rounded-full" data-id="element-317"></div>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-318">
          {/* Card 1 */}
          <div className="bg-white p-8 rounded-xl shadow-lg border border-teal-100 transform transition-all duration-300 hover:shadow-xl hover:-translate-y-1" data-id="element-319">
            <div className="bg-teal-50 w-16 h-16 flex items-center justify-center rounded-full mb-6 mx-auto" data-id="element-320">
              <Users className="h-8 w-8 text-teal-700" data-id="element-321" />
            </div>
            <h3 className="text-xl font-bold text-teal-900 mb-4 text-center" data-id="element-322">
              Unlimited Client Access — Done-For-You Setup
            </h3>
            <p className="text-gray-700" data-id="element-323">
              Give every client their own login to the full Neurotoned healing
              library—at no extra cost. Just send us their emails and we'll
              onboard them within 48 hours. No tech headaches. No limits. No
              added fees. More value for your clients, less work for you.
            </p>
          </div>
          {/* Card 2 */}
          <div className="bg-white p-8 rounded-xl shadow-lg border border-teal-100 transform transition-all duration-300 hover:shadow-xl hover:-translate-y-1" data-id="element-324">
            <div className="bg-teal-50 w-16 h-16 flex items-center justify-center rounded-full mb-6 mx-auto" data-id="element-325">
              <Library className="h-8 w-8 text-teal-700" data-id="element-326" />
            </div>
            <h3 className="text-xl font-bold text-teal-900 mb-4 text-center" data-id="element-327">
              Full Somatic Library + Biweekly Live Support Calls
            </h3>
            <p className="text-gray-700" data-id="element-328">
              Your clients get access to 30+ trauma-informed, body-based
              programs—plus the option to join live support calls every other
              week, led by our expert facilitators. This means more consistent
              nervous system regulation, better outcomes, and deeper progress
              between sessions.
            </p>
          </div>
          {/* Card 3 */}
          <div className="bg-white p-8 rounded-xl shadow-lg border border-teal-100 transform transition-all duration-300 hover:shadow-xl hover:-translate-y-1" data-id="element-329">
            <div className="bg-teal-50 w-16 h-16 flex items-center justify-center rounded-full mb-6 mx-auto" data-id="element-330">
              <TrendingUp className="h-8 w-8 text-teal-700" data-id="element-331" />
            </div>
            <h3 className="text-xl font-bold text-teal-900 mb-4 text-center" data-id="element-332">
              Better Results = Longer Retention
            </h3>
            <p className="text-gray-700" data-id="element-333">
              When your clients feel real, embodied change—fast—they stick with
              you longer. This toolkit helps them experience those "breakthrough
              moments" more often, without needing you to do all the heavy
              lifting. You become the practitioner who finally helped it click.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default WhyPractitionersSection;